export default __webpack_public_path__ + "static/media/jackpot.e7469fdb.svg";